import _styled from "@emotion/styled/base";
import React, { memo, useEffect } from 'react';
import { shape, string } from 'prop-types';
import useScript from './useScript';
var LANDSCAPE_RATIO = '56.25%';
/**
 * Apply provider-specific styles.
 */

var OEmbed = _styled("div", {
  target: "e181078e0",
  label: "OEmbed"
})(function (_ref) {
  var styles = _ref.styles;
  return styles;
}, " display:flex;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/**
 * The following object declares a list of supported Canonical providers
 * and their attributes. Not all providers have the same attributes.
 */


export var providers = {
  instagram: {
    script: 'https://www.instagram.com/embed.js',
    styles: "\n      .instagram-media {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n        min-width: auto !important;\n      }\n    ",
    enrich: function enrich() {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    }
  },
  twitter: {
    script: 'https://platform.twitter.com/widgets.js',
    styles: "\n      .twitter-tweet {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n      }\n    ",
    enrich: function enrich() {
      if (window.twttr) {
        window.twttr.widgets.load();
      }
    }
  },
  youtube: {
    styles: "\n      padding-top: ".concat(LANDSCAPE_RATIO, ";\n      position: relative;\n      overflow: hidden;\n\n      > iframe {\n        border: none;\n        height: 100%;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n      }\n    "),
    enrich: function enrich() {}
  }
};

var CanonicalEmbed = function CanonicalEmbed(_ref2) {
  var provider = _ref2.provider,
      oEmbed = _ref2.oEmbed;
  useScript(providers[provider].script);
  useEffect(providers[provider].enrich);
  return /*#__PURE__*/React.createElement(OEmbed, {
    styles: providers[provider].styles,
    dangerouslySetInnerHTML: {
      __html: oEmbed.html
    }
  });
};

CanonicalEmbed.propTypes = {
  provider: string.isRequired,
  oEmbed: shape({
    html: string.isRequired
  }).isRequired
};
export default /*#__PURE__*/memo(CanonicalEmbed);